'use client';
import styled from 'styled-components';

export const HorizontalRule = styled.hr`
  border-width: 0.5px;
  color: ${props => props.theme.colors.border.fur};
  margin: ${props => props.theme.spacing(props.spacing || 3)} 0;
  opacity: ${props => (props.light ? 0.25 : 0.5)};
  width: 100%;

  @media ${props => props.theme.tabletL} {
    width: ${props => props.width};
  }
`;
